<template>
  <div>
    <b-modal
      v-model="configModal.show"
      id="modal-1"
      @ok="submit"
      @close="close"
      @cancel="close"
      title="Chọn đơn vị cung cấp"
      no-close-on-backdrop no-enforce-focus
    >
      <el-form
        :model="mData.dataForm"
        :rules="mData.validForm"
        ref="myFormDonViCungCap"
        label-width="100%"
        label-position="top"
      >
        <b-row>
          <b-col md="12">
            <el-form-item
              label="Chọn đơn vị cung cấp"
              prop="don_vi_cung_cap_id"
            >
              <el-select
                placeholder="Chọn đơn vị cung cấp"
                clearable
                v-model="mData.dataForm.don_vi_cung_cap_id"
                filterable
              >
                <el-option
                  v-for="item in mData.danhSachDonViCungCap"
                  :key="item.id"
                  :label="item.du_lieu_khai_bao.user_ten"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </b-modal>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DiemDenModel from '@/views/admin/DiemDen/DiemDenModel';
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
export default {
  props: ["configModal" ,"dataObject"],
  components: {},
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VuiChoiGiaiTri",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataDefault: {
          listProvince: [],
        },
        danhSachDonViCungCap: [],
        dataForm: MethodService.copyObject(DiemDenModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          DiemDenModel.dataFormOther.fileUploadOption
        ),
        validForm: DiemDenModel.validForm,
      },
    };
  },
  methods: {
    async load(keyword = "") {
      const res = await DonViCungCapApi.list({
        filters:  ["loai=yellow_page_place"],
        limit: 1000000
      });
      this.mData.danhSachDonViCungCap = res.result;
    },
    async submit(evt) {
      evt.preventDefault();
      this.$refs["myFormDonViCungCap"].validate(async (valid) => {
         if (valid) {
          this.$emit("submit", {
            donViCungCapId: this.mData.dataForm.don_vi_cung_cap_id,
          });
        }
      });
    },
    close() {
      this.show = false;
    }
  },

  mounted() {
    this.load();
  },
};
</script>
